import TriggerBase from './trigger-base';

/**
 * handles onLoad lazy-load elements
 */
export default class OnLoad extends  TriggerBase {

	constructor( element ) {
		super( element );
		this.event = 'DOMContentLoaded';
		this.addListener();
	}

	addListener() {
		// cover case where already loaded
		if ( document.readyState === 'complete' || document.readyState === 'loaded' ) {
			this.trigger().then();
			return;
		}
		setTimeout( () => this.trigger(), 100 );
	}
}
